/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/collections/v1/api.proto
 * OpenAPI spec version: version not set
 */

export type GetCollectionStage =
  (typeof GetCollectionStage)[keyof typeof GetCollectionStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCollectionStage = {
  COLLECTION_STAGE_UNSPECIFIED: 'COLLECTION_STAGE_UNSPECIFIED',
  COLLECTION_STAGE_DRAFT: 'COLLECTION_STAGE_DRAFT',
  COLLECTION_STAGE_PUBLISHED: 'COLLECTION_STAGE_PUBLISHED',
} as const;
